import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { IThreatAssessmentTeam } from '../../../../../shared/models/contact';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SpinnerComponent } from '../../../../components/spinner/spinner.component';

@Component({
  selector: 'rms-review-official-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent
  ],
  templateUrl: './rms-review-official-signature.component.html',
  styleUrl: './rms-review-official-signature.component.css'
})
export class RmsReviewOfficialSignatureComponent implements OnInit, OnChanges {

  @Input() rmsRecordReviewData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  yesNo = EYesNo;
  rmsRecordReviewSignatureForm: FormGroup = new FormGroup([]);
  
  currentDate = new Date();
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  currentContact: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private contactsService: ContactsService,
    private userDataService: UserDataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentContact = this.userDataService.getCurrentUser();

    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rmsRecordReviewData'] && this.rmsRecordReviewData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.rmsRecordReviewSignatureForm = new FormGroup({
      user_signature_name: new FormControl('', Validators.required),
    });
  }

  saveReviewerInfo(): void {
    if (this.rmsRecordReviewSignatureForm.valid) {
      const data = this.rmsRecordReviewSignatureForm.value;
      this.onSaveSection3.emit(data);
    }
  }

}
